import CONSTANTS from '../services/constants/constantStrings'

const Storage = {
    getLocalStorageData (key) {
        try {
            key = CONSTANTS.KEY_PREFIX + key
            const stringifiedValue = localStorage.getItem(key) 
            try {
                return JSON.parse(stringifiedValue)
            } catch { // value is not JSON parsable
                return stringifiedValue
            }
        } catch (e) {
            console.log('Local Storage error', e)
        }
    },
    
    setLocalStorageData (key, value) {
        try {
            key = CONSTANTS.KEY_PREFIX + key
            let stringifiedValue = JSON.stringify(value)
            localStorage.setItem(key, stringifiedValue)
        } catch (e) {
            console.log('Local Storage error', e)
        }
    },
    
    removeLocalStorageData (key) {
        try {
            key = CONSTANTS.KEY_PREFIX + key
            localStorage.removeItem(key)
        } catch (e) {
            console.log('Local Storage error', e)
        }
    },

    setSessionStorageData(key, value) {
        try {
            key = CONSTANTS.KEY_PREFIX + key
            let stringifiedValue = JSON.stringify(value)
            sessionStorage.setItem(key, stringifiedValue)
        } catch (e) {
            console.log('Session Storage error', e)
        }
    },

    removeSessionStorageData (key) {
        try {
            key = CONSTANTS.KEY_PREFIX + key
            sessionStorage.removeItem(key)
        } catch (e) {
            console.log('Session Storage error', e)
        }
    },

    getSessionStorageData(key) {
        try {
            key = CONSTANTS.KEY_PREFIX + key
            const stringifiedValue = sessionStorage.getItem(key) 
            try {
                return JSON.parse(stringifiedValue)
            } catch { // value is not JSON parsable
                return stringifiedValue
            }
        } catch (e) {
            console.log('Session Storage error', e)
        }
    }

}

export default Storage
